export default __webpack_public_path__ + "static/Efficiency-improvement-9d9d443c151ce6844a3918a711889252.webp";